import React, { useCallback, useEffect, useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { getProperties } from '../../../../../Services';
import { AutocompleteComponent } from '../../../../../Components';

export const PropertyComponent = ({
  parentTranslationPath,
  translationPath,
  onInputChanged,
  IDView = false
}) => {
  const { t } = useTranslation([parentTranslationPath, 'Shared']);
  const searchTimer = useRef(null);
  const [properties, setProperties] = useState([]);
  const [propertySearch, setPropertySearch] = useState(null);
  const [state, setState] = useState([]);
  const GetAllProperties = useCallback(async () => {
    const res = await getProperties({ pageSize: 50, pageIndex: 0, search: propertySearch });
    if (!(res && res.status && res.status !== 200)) {
      const mapped = [];
      res.result.map((item) => {
        mapped.push({
          propertyId: item.propertyId,
          propertyName: item.property && item.property.property_name,
          property_plan: item.property && item.property.property_plan && item.property.property_plan.lookupItemName
        });
      });
      setProperties(mapped || []);
    } else setProperties([]);
  }, [propertySearch]);

  useEffect(() => {
    GetAllProperties();
  }, [propertySearch]);

  return (
    <>
      <div className='dialog-content-item'>
        <AutocompleteComponent
          idRef='PropertiesIdRef'
          selectedValues={
            state?.map((item) => ({
              propertyId: item.propertyId,
              propertyName: item?.propertyName && item?.propertyName || '',

            })
            )}
          inputPlaceholder={'Select Properties'}
          data={properties && properties || []}
          multiple
          filterSelectedOptions
          getOptionSelected={(option) =>
            state.findIndex((item) => item.propertyId === option.propertyId) !== -1 || ''}
          displayLabel={(option) => !IDView &&

            (`${option && option?.propertyName || ' '}${`      (      ${(option && option?.property_plan || '')}      ) `}` || '')
            || (`${option && option?.propertyId || ' '}${`      (      ${(option && option?.propertyName || '')}      ) `}` || '')
          }
          chipsLabel={(option) => (
            !IDView &&
            (option && option?.propertyName || '') ||
            (option && option?.propertyName || '')) || ''}

          withoutSearchButton
          parentTranslationPath={parentTranslationPath}
          translationPath={translationPath}
          onChange={(event, newValue) => {
            const uniqueProperties = newValue.filter(
              (item, index, self) =>
                index === self.findIndex(p => p.propertyId === item.propertyId)
            );

            setState(uniqueProperties);

            if (typeof onInputChanged === 'function') {
              onInputChanged(
                { propertyIds: uniqueProperties.map((p) => p.propertyId) },
                'propertyIds'
              );
            }
          }}

          onInputKeyUp={(event) => {
            const { value } = event.target;
            if (searchTimer.current) clearTimeout(searchTimer.current);
            searchTimer.current = setTimeout(() => {
              setPropertySearch(value);
            }, 1700);
          }}
          filterOptions={(options) => {
            const isFound = (id) => state || [].findIndex((item) => item?.propertyId === id) === -1;
            return options && options || [].filter((option) => isFound(option?.propertyId));
          }}
        />
      </div>
    </>
  );
};


